/** Rutas madre que nunca deben considerarse activas por prefijo de navegación. */
const SUB_ACTIVE_EXACT_PATHS = new Set(['/app/catalog', '/app/bot-settings'])

/**
 * Marca un submenú del sidebar como activo: exacto por igualdad o por prefijo,
 * salvo las rutas madre (Catálogo, Agente IA/Bot) que exigirían igualdad exacta.
 */
export function isNavSubActive(pathname: string, subPath: string): boolean {
  if (pathname === subPath) return true
  if (SUB_ACTIVE_EXACT_PATHS.has(subPath)) return false
  return pathname.startsWith(`${subPath}/`)
}
